document.addEventListener('DOMContentLoaded', () => {
  const productForm = document.querySelector('.we-buy-form');
  const sperrgutWrapper = document.querySelector('.we-sperrgut-wrapper');
  const sperrgutSelection = sperrgutWrapper.querySelector('.we-sperrgut-selection');
  const sperrgutRadioButtons = sperrgutWrapper.querySelectorAll('input[name="sperrgut"]');

  const sperrgutSelection1 = {
    quantityPlus: sperrgutSelection.querySelector('.selection-1 .quantity__button--plus'),
    quantityMinus: sperrgutSelection.querySelector('.selection-1 .quantity__button--minus'),
    quantityInput: sperrgutSelection.querySelector('.selection-1 .quantity__input'),
    productFormNodes: getProductFormNodes('selection-1'),
  }

  const sperrgutSelection2 = {
    quantityPlus: sperrgutSelection.querySelector('.selection-2 .quantity__button--plus'),
    quantityMinus: sperrgutSelection.querySelector('.selection-2 .quantity__button--minus'),
    quantityInput: sperrgutSelection.querySelector('.selection-2 .quantity__input'),
    productFormNodes: getProductFormNodes('selection-2'),
  }




  function main(){
    initSperrgutRadioButtonsListeners();
    initSperrgutSelection1Listeners();
    initSperrgutSelection2Listeners();
  }

  function getProductFormNodes(selection){
    const paletteId = '50133971075400'
    const gitterBoxenId = '50133973696840'
    const selectionMap = {
      'selection-1': {
        id: paletteId,
        item: '1',
      },
      'selection-2': {
        id: gitterBoxenId,
        item: '2',
      },
    }
    const idInput = document.createElement('input');
    idInput.name = `items[${selectionMap[selection].item}][id]`;
    idInput.value = `${selectionMap[selection].id}`;
    idInput.type = 'hidden';

    const quantityInput = document.createElement('input');
    quantityInput.name = `items[${selectionMap[selection].item}][quantity]`;
    quantityInput.value = '1';
    quantityInput.type = 'hidden';

    return {idInput, quantityInput};
  }

  function initSperrgutRadioButtonsListeners(){
    sperrgutRadioButtons.forEach(radio => {
      radio.addEventListener('change', () => {
        const selectedValue = radio.value;
        if (selectedValue === 'yes') {
        sperrgutSelection.classList.remove('we-hide');
      } else {
          sperrgutSelection.classList.add('we-hide');
          if(sperrgutSelection1.quantityInput.value > 0){
            removeFromProductForm(sperrgutSelection1.productFormNodes);
            updateQuantityInput(sperrgutSelection1.productFormNodes.quantityInput, 0);
            sperrgutSelection1.quantityInput.value = 0;
          }
          if(sperrgutSelection2.quantityInput.value > 0){
            removeFromProductForm(sperrgutSelection2.productFormNodes);
            updateQuantityInput(sperrgutSelection2.productFormNodes.quantityInput, 0);
            sperrgutSelection2.quantityInput.value = 0;
          }
        }
      })
    })
  }

  function initSperrgutSelection1Listeners(){
    sperrgutSelection1.quantityPlus.addEventListener('click', () => {
      sperrgutSelection1.quantityInput.value++;
      if(sperrgutSelection1.quantityInput.value == 1){
        addToProductForm(sperrgutSelection1.productFormNodes);
      }
      updateQuantityInput(sperrgutSelection1.productFormNodes.quantityInput, sperrgutSelection1.quantityInput.value);
    });

    sperrgutSelection1.quantityMinus.addEventListener('click', () => {
      if(sperrgutSelection1.quantityInput.value > 0){
        sperrgutSelection1.quantityInput.value--;
        if(sperrgutSelection1.quantityInput.value == 0){
          removeFromProductForm(sperrgutSelection1.productFormNodes);
        }
        updateQuantityInput(sperrgutSelection1.productFormNodes.quantityInput, sperrgutSelection1.quantityInput.value);
      }
    });
  }

  function initSperrgutSelection2Listeners(){
    sperrgutSelection2.quantityPlus.addEventListener('click', () => {
      sperrgutSelection2.quantityInput.value++;
      if(sperrgutSelection2.quantityInput.value == 1){
        addToProductForm(sperrgutSelection2.productFormNodes);
      }
      updateQuantityInput(sperrgutSelection2.productFormNodes.quantityInput, sperrgutSelection2.quantityInput.value);
    });
    
    sperrgutSelection2.quantityMinus.addEventListener('click', () => {
      if(sperrgutSelection2.quantityInput.value > 0){
        sperrgutSelection2.quantityInput.value--;
        if(sperrgutSelection2.quantityInput.value == 0){
          removeFromProductForm(sperrgutSelection2.productFormNodes);
        }
        updateQuantityInput(sperrgutSelection2.productFormNodes.quantityInput, sperrgutSelection2.quantityInput.value);
      }
    });
  }

  function addToProductForm(productFormNodes){
    productForm.appendChild(productFormNodes.idInput);
    productForm.appendChild(productFormNodes.quantityInput);
  }

  function removeFromProductForm(productFormNodes){
    productForm.removeChild(productFormNodes.idInput);
    productForm.removeChild(productFormNodes.quantityInput);
  }

  function updateQuantityInput(quantityInput, value){
    quantityInput.value = value;
  }

  main()
});

